import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminOrdersTranslation } from "../../translations";

const StatusUpdateSection = ({ order, updating, onStatusUpdate }) => {
    const { language } = useLanguage();
    const { t } = useAdminOrdersTranslation(language);

    const statusOptions = [
        { key: "Pending", label: t('statusPending') },
        { key: "Processing", label: t('statusProcessing') },
        { key: "Shipped", label: t('statusShipped') },
        { key: "Delivered", label: t('statusDelivered') },
        { key: "Cancelled", label: t('statusCancelled') },
        { key: "Refunded", label: t('statusRefunded') },
        { key: "Confirmed", label: t('statusConfirmed') }
    ];

    return (
        <div className="status-update-section">
            <h2>{t('updateStatus')}</h2>
            <div className="status-buttons">
                {statusOptions.map((status) => (
                    <button
                        key={status.key}
                        className={`status-btn ${status.key.toLowerCase()} ${order.status === status.key ? "active" : ""
                            }`}
                        onClick={() => onStatusUpdate(status.key)}
                        disabled={updating || order.status === status.key}
                    >
                        {status.label}
                    </button>
                ))}
            </div>
            {updating && (
                <div className="updating-indicator">{t('updating')}</div>
            )}
        </div>
    );
};

export default StatusUpdateSection;